import flatten from 'lodash/flatten';
import pick from 'lodash/pick';

export async function getList({commit}, fileExtension) {
  const response = await this.$adminRepositories.applications.index(
    fileExtension);
  const {errResponse, data} = response;

  if (!errResponse) {
    commit('setList', data.data);
  }

  return response;
}

export async function deleteApplication({commit}, id) {
  return await this.$adminRepositories.applications.delete(id);
}

export async function createApplication({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const {data} = await this.$adminRepositories.applications.create(payload);
  commit('setBtnLoading', false, {root: true});
  return data;
}

export async function updateApplication({commit}, payload) {
  return await this.$adminRepositories.applications.update(payload.id,
    payload);
}

export async function updatePublish({commit}, payload) {
  const response = await this.$adminRepositories.applications.updatePublish(
    payload);

  if (!response.errResponse) {
    commit('updatePublishById', {id: payload.id, publish: response.data.data});
  }
}

export async function getApplicationById({commit}, payload) {
  return await this.$adminRepositories.applications.show(payload);
}

export async function findApplicationById({commit}, payload) {
  const {data} = await this.$adminRepositories.applications.show(payload);
  commit('setApplication', data.data);

  return data;
}

export async function createOrUpdateFolder({commit}, payload) {
  return await this.$adminRepositories.applications.createOrUpdateFolder(payload);
}

export async function createField({commit}, payload) {
  const response = await this.$adminRepositories.applications.createField(
    payload);
  commit('addField', response.data.data);
}

export async function updateField({commit, state, dispatch}, {id, payload}) {
  const {data: responseData} = await this.$adminRepositories.applications.updateField(
    id, payload);

  await dispatch('findApplicationById', responseData.data.app_id);
  /** TODO: maybe change flow update particles */
  // commit('setApplication', responseData.data);

  // commit('updateField', {
  //   id,
  //   payload: responseData.data,
  // });

  /*== Update instance field ==*/
  // responseData.data.instances.forEach(instance => {
  //   commit('updateInstanceField', instance);
  // });
  //
  // const instanceIds = pluck(responseData.data.instances, 'id');
  //
  // const optionIds = pluck(responseData.data.options.options, 'id');
  //
  // /*== Save options for question ==*/
  // state.application.questions.forEach(question => {
  //   if (!instanceIds.includes(question.options?.instance_id)) {
  //     return;
  //   }
  //
  //   const instanceOption = question.options.instance_option.filter(
  //     option => optionIds.includes(option.id));
  //
  //   if (!instanceOption.length) {
  //     commit('saveOptionForQuestion', {
  //       settings: false,
  //       instance_id: !isEmpty(optionIds) ? question.options.instance_id : null,
  //       instance_option: !isEmpty(optionIds) ?
  //         question.options.instance_option :
  //         [],
  //       question_id: question.id,
  //     });
  //   }
  // });

  return responseData;
}

export async function createInstanceField({commit}, payload) {
  payload.name = payload.name.substr(0, 25);
  const {
    errResponse,
    data: responseData,
  } = await this.$adminRepositories.applications.createInstanceField(payload);

  if (!errResponse) {
    if (responseData.data?.ruleData) {
      commit('addRule', responseData.data.ruleData);
      delete responseData.data.ruleData;
    }
    commit('addInstanceToField', responseData.data);
  }

  return responseData;
}

export async function updatePosition({commit}, data) {
  let obj = data.item;
  obj.position.x = data.newPosition.x;
  obj.position.y = data.newPosition.y;

  await commit('updateInstanceField', obj);
}

export async function updateInstanceField({commit}, {payload, id}) {
  const {
    data: responseData,
    errResponse,
  } = await this.$adminRepositories.applications.updateInstanceField(id,
    payload);

  if (!errResponse) {
    commit('updateInstanceField', responseData.data);
  }

  return responseData;
}

export async function deleteFieldInstance(
  {commit, dispatch, state}, {id, fieldId}) {
  const response = await this.$adminRepositories.applications.deleteFieldInstance(
    id);
  const {errResponse, data: responseData} = response;

  if (!errResponse) {
    /** TODO: maybe change flow update particles */
    commit('setApplication', responseData.data);

    return response;
  }

  return response;
}

export async function deleteField({commit, state}, payload) {
  const {
    errResponse,
    data: responseData,
  } = await this.$adminRepositories.mstFields.delete(payload);

  if (!errResponse && responseData.success) {
    /** TODO: maybe change flow update particles */
    commit('setApplication', responseData.data);
  }

  return responseData;
}

export async function createQuestion({commit}, payload) {
  const response = await this.$adminRepositories.applications.createQuestion(
    payload);
  commit('addQuestion', response.data.data);
  return response;
}

export async function updateQuestion({commit}, payload) {
  const response = await this.$adminRepositories.applications.updateQuestion(
    payload.id, payload);
  commit('updateQuestion', response.data.data);
  return response;
}

export async function deleteQuestion({commit, state}, id) {
  const response = await this.$adminRepositories.applications.deleteQuestion(
    id);

  const {data: responseData} = response;

  commit('removeQuestion', id);

  state.application.questions.filter(
    question => responseData.data.other_question_ids.includes(question.id)).
    forEach(question => {
      commit('saveOptionForQuestion', {
        settings: false,
        instance_id: null,
        question_id: question.id,
        instance_option: [],
        must_meet_all_conditions: false,
      });
    });

  /*== Remove repeat question ==*/
  state.application.questions.filter(
    question => question.repeat_options !== null).forEach(question => {
    const repeatOptions = {
      ...question.repeat_options,
      questions: question.repeat_options.questions.map(
        q => q.filter(item => item !== id)),
    };

    commit('updateQuestion', {
      ...question,
      repeat_options: repeatOptions,
    });
  });

  /*== Set question to instance ==*/
  state.application.fields.forEach(field => {
    field.instances.forEach(instance => {
      if (instance.question?.id === id) {
        commit('setQuestionToInstance', {
          fieldId: field.id,
          instanceId: instance.id,
          payload: null,
        });
      }
    });
  });

  return response;
}

export async function createSurveyQuestionField({state, commit}, payload) {
  await commit('showPageLoading', {}, {root: true});
  const response = await this.$adminRepositories.applications.createSurveyQuestionField(
    payload);
  const responseData = response.data.data;
  await commit('addSurveyQuestionField', responseData);
  await commit('hidePageLoading', {}, {root: true});

  return response;
}

export async function updateSurveyQuestionField({commit}, {formData, id}) {
  const response = await this.$adminRepositories.applications.updateSurveyQuestionField(
    id, formData);
  await commit('updateSurveyQuestionField', response.data.data);
  return response;
}

export async function deleteSurveyQuestionField({commit, state}, payload) {
  const response = await this.$adminRepositories.applications.deleteSurveyQuestionField(
    payload.surveyQuestionFieldId);

  commit('removeSurveyQuestionField', payload);

  return response;
}

export async function sortSurveyQuestionField({commit}, payload) {
  return await this.$adminRepositories.applications.sortSurveyQuestionField(payload);
}

export async function createFieldGroup({state, commit}, payload) {
  await commit('showPageLoading', {}, {root: true});
  const response = await this.$adminRepositories.applications.createFieldGroup(
    payload);
  const responseData = response.data.data;
  await commit('addFieldGroup', responseData);

  /* Set question to instance */
  const question = state.application.questions.find(
    question => question.id === responseData[0]?.question_id);

  if (question) {
    flatten(responseData.map(item => item.fields)).forEach(field => {
      commit('setQuestionToInstance', {
        fieldId: field.mst_field_id,
        instanceId: field.id,
        payload: question,
      });

      commit('setFieldGroupIdToInstance', {
        fieldId: field.mst_field_id,
        instanceId: field.id,
        payload: field.field_group_id,
      });
    });
  }

  await commit('hidePageLoading', {}, {root: true});

  return response;
}

export async function updateFieldGroup({commit}, payload) {
  const response = await this.$adminRepositories.applications.updateFieldGroup(
    payload.id, payload);
  await commit('updateFieldGroup', response.data.data);
  return response;
}

export async function updateOptions({commit}, payload) {
  const response = await this.$adminRepositories.applications.updateOptions(
    payload.question_id, payload.options);

  await commit('saveOptionForQuestion', {
    ...response.data.data,
    question_id: payload.question_id,
  });

  return response;
}

export async function updateQuestionCondition({commit}, {id, payload}) {
  const {errResponse, data: responseData} = await this.$adminRepositories.applications.updateQuestionCondition(id, payload);
   if (!errResponse && responseData.success) {
    await commit('saveOptionForQuestion', {
      ...responseData.data,
      question_id: id,
    });
  }
  return responseData;
}

export async function updateGroupCondition({commit}, {id, question_id, payload}) {
  const {errResponse, data: responseData} = await this.$adminRepositories.applications.updateGroupCondition(id, payload);
  if (!errResponse && responseData.success) {
    await commit('saveOptionForFieldGroup', {
      options: responseData.data,
      field_group_id: id,
      question_id
    });
  }
  return responseData;
}

export async function updateFieldCondition({commit}, {id, mst_field_id, field_group_id, payload}) {
  const {errResponse, data: responseData} = await this.$adminRepositories.applications.updateFieldCondition(id, payload);
   if (!errResponse && responseData.success) {
    await commit('saveOptionForField', {
      id,
      options: responseData.data,
      mst_field_id,
      field_group_id
    });
  }
  return responseData;
}

export async function updateQuestionModal({commit}, {id, payload}) {
  const {errResponse, data: responseData} = await this.$adminRepositories.applications.updateQuestionModal(id, payload);
  if (!errResponse && responseData.success) {
    await commit('saveModalForQuestion', responseData.data);
  }
  return responseData;
}

export async function updateGroupModal({commit}, {id, payload}) {
  const {errResponse, data: responseData} = await this.$adminRepositories.applications.updateGroupModal(id, payload);
  if (!errResponse && responseData.success) {
    await commit('saveModalForFieldGroup', responseData.data);
  }
  return responseData;
}

export async function updateSurveyModal({commit}, {id, payload}) {
  const {errResponse, data: responseData} = await this.$adminRepositories.applications.updateSurveyModal(id, payload);
  if (!errResponse && responseData.success) {
    await commit('saveModalForSurveyField', responseData.data);
  }
  return responseData;
}

export async function deleteFieldGroup({commit, state}, payload) {
  const response = await this.$adminRepositories.applications.deleteFieldGroup(
    payload.fieldGroupId);

  commit('removeFieldGroup', payload);

  /* Reset settings */
  state.application.questions.forEach(question => {
    if (payload.fieldIds.includes(question.options?.instance_id)) {
      const options = {
        settings: false,
        instance_id: null,
        instance_option: [],
        question_id: question.id,
      };

      commit('saveOptionForQuestion', options);
    }
  });

  /* Set question to instance */
  state.application.fields.map(field => {
    field.instances.map(instance => {
      if (payload.fieldIds.includes(instance.id)) {
        commit('setQuestionToInstance', {
          fieldId: field.id,
          instanceId: instance.id,
          payload: null,
        });
      }
    });
  });

  return response;
}

export async function sortFieldGroup({commit}, payload) {
  return await this.$adminRepositories.applications.sortFieldGroup(payload);
}

export async function sortQuestion({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$adminRepositories.applications.sortQuestion(
    payload);
  commit('setQuestions', response.data.data);
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function refreshQuestion({commit}, payload) {
  const response = await this.$adminRepositories.applications.refreshQuestion(payload);
  commit('setQuestions', response.data.data);
  return response;
}

export async function updateAllQuestionConfig({commit}, payload) {
  const response = await this.$adminRepositories.applications.updateAllQuestionConfig(payload);
  commit('setQuestions', response.data.data);
  return response;
}

export async function sortField({commit}, payload) {
  return this.$adminRepositories.applications.sortField(payload);
}

export async function updateFieldPlaceholder({commit}, {questionId, payload}) {
  const response = await this.$adminRepositories.applications.updateFieldPlaceholder(
    payload);

  commit('updateFieldOptionForQuestion', {
    questionId,
    payload: response.data.data,
  });

  return response;
}

export async function removeFieldInstancesFromIdListHandle({commit}, payload) {
  commit('removeFieldInstancesFromIdList', payload);
}

export function setFile({commit}, file) {
  commit('setFile', file);
}

export async function updateQuestionNotification({commit}, payload) {
  const response = await this.$adminRepositories.applications.updateQuestionNotification(payload);
  return response;
}

export async function updateContentNotification({commit}, formData) {
  const response = await this.$adminRepositories.applications.updateContentNotification(formData);
  return response;
}

export async function previewQuestionNotification({commit}, appId) {
  const response = await this.$adminRepositories.applications.previewQuestionNotification(appId);
  return response;
}

export async function saveNewVersion({commit}, id) {
  const {data} = await this.$adminRepositories.applications.saveNewVersion(id);

  return data;
}

export async function sortFile({commit}, payload) {
  return await this.$adminRepositories.applications.sortFile(payload);
}

export async function sortFolder({commit}, payload) {
  return await this.$adminRepositories.applications.sortFolder(payload);
}

export async function addRule({commit, state}, payload) {
  const response = await this.$adminRepositories.applications.createRule(state.application.id, payload);

  const {data: responseData} = response;
  if(payload.id) {
    await commit('updateRule', responseData.data);
  } else {
    await commit('addRule', responseData.data);
  }

  return response;
}

export async function findRuleById({commit}, ruleId) {
  const {errResponse, data: responseData} = await this.$adminRepositories.applications.findRuleById(ruleId);
  if (!errResponse && responseData.success) {
    await commit('updateRule', responseData.data);
  }
  return responseData;
}

export async function createRule({commit, dispatch}, payload) {
  await dispatch('saveManyInstances');
  return await this.$adminRepositories.applications.createRule(payload);
}

export async function updateRule({commit, dispatch}, {id, payload}) {
  await dispatch('saveManyInstances');
  return await this.$adminRepositories.applications.updateRule(id, payload);
}

export async function deleteRule({commit, dispatch}, ruleId) {
  await dispatch('saveManyInstances');
  return await this.$adminRepositories.applications.deleteRule(ruleId);
}

export async function sortRule({commit, dispatch}, payload) {
  const response = await this.$adminRepositories.applications.sortRule(payload);
  commit('setRules', response.data.data);
  return response;
}

export async function saveManyInstances({state}) {
  const body = flatten(state.application.fields.map(field => field.instances)).
    filter(field => field.file_id === state.file.id).
    map(field => {
      return pick(field, [
        'id',
        'name',
        'style',
        'position',
        'options',
      ]);
    });

  const {
    errResponse,
    data: responseData,
  } = await this.$adminRepositories.applications.saveMultipleInstances({
    body,
  });

  if (errResponse) {
    return Promise.reject(responseData.message);
  }

  return Promise.resolve(responseData.message);
}

export async function saveNewPdfFile({state}, payload) {
  const {errResponse, data: responseData} = await this.$adminRepositories.applications.saveNewPdfFile(payload);

  return responseData;
}

export async function getAll({commit}, fileExtension) {
  const response = await this.$adminRepositories.applications.getAll();
  const {errResponse, data} = response;

  if (!errResponse) {
    commit('setAllApplication', data.data);
  }

  return response;
}

export async function cloneApplication({_}, id) {
  const {errResponse, data: responseData} = await this.$adminRepositories.applications.cloneApplication(id);

  return responseData;
}

export async function getAppUserById({commit}, id) {
  const {errResponse, data: responseData} = await this.$adminRepositories.applications.getAppUserById(id);

  if (!errResponse) {
    commit('setAppUser', responseData.data);
  }
}

export async function confirmAppUser({commit}, id) {
  const {errResponse, data: responseData} = await this.$adminRepositories.applications.confirmAppUser(id);

  if (!errResponse) {
    commit('setAppUser', responseData.data);
    return responseData.message;
  }
  return null;
}

export async function getListApplicationUser({commit}, payload) {
  const {errResponse, data: responseData} = await this.$adminRepositories.applications.getListApplicationUser(payload);

  if (!errResponse) {
    commit('setListAppUser', responseData.data);
  }
}

export async function getFilterProjectList({commit}, payload = {}) {
  const {errResponse, data: responseData} = await this.$adminRepositories.applications.getFilterProjectList(payload);

  if (!errResponse) {
    commit('setAllApplication', responseData.data);
  }
}

export async function getApplicationQuantity({commit}) {
  const {errResponse, data: responseData} = await this.$adminRepositories.applications.getApplicationQuantity();

  if (!errResponse) {
    commit('setQuantityAppUser', responseData.data);
  }
}

export async function getListFilterTransaction({commit}) {
  const {errResponse, data: responseData} = await this.$adminRepositories.applications.getListFilterTransaction();

  if (!errResponse) {
    commit('setListFilterTransaction', responseData.data);
  }
}

export async function getApplicationUserSteps({ commit }) {
  const { errResponse, data: responseData } = await this.$adminRepositories.applications.getApplicationUserSteps()

  if (!errResponse) {
    commit('setListFilterStep', responseData.data)
  }
}
export async function getCampaignEmailTemplates({ commit }) {
  const { errResponse, data: responseData } = await this.$adminRepositories.applications.getCampaignEmailTemplates()

  if (!errResponse) {
    commit('setCampaignEmailTemplate', responseData.data[0])
  }
}

export async function getAppCampaignsWithFilter({commit}, payload = {}) {
  const {errResponse, data: responseData} = await this.$adminRepositories.applications.getAppCampaignsWithFilter(payload);
  if (!errResponse) {
    return responseData.data;
  }

  return [];
}

export async function getAppCampaigns({commit}, payload = {}) {
  const {errResponse, data: responseData} = await this.$adminRepositories.applications.getAppCampaignsWithFilter(payload);
  if (!errResponse) {
    return responseData.data;
  }

  return [];
}

export async function getFilterAttributeForAppCampaign({commit}) {
  const {errResponse, data: responseData} = await this.$adminRepositories.applications.getFilterAttributeForAppCampaign();
  if (!errResponse) {
    return responseData.data;
  }

  return [];
}
